import {apiRoutes} from 'app/globals';
import * as api from 'app/lib/ajax';


export const getVisits = (filters) => (
    !process.env.REACT_APP_MOCK ? api.get(apiRoutes.GET_VISITS,{query:filters}) : () => require('./mock').getVisits()
);

export const getVisit = (vtrac) => (
    !process.env.REACT_APP_MOCK ? api.get(apiRoutes.GET_VISIT({vtrac})) : () => require('./mock').getVisit(vtrac)
);

export const getVisitUnits = (vtrac) => (
    !process.env.REACT_APP_MOCK ? api.get(apiRoutes.GET_VISIT_UNITS({vtrac})) : () => require('./mock').getVisitUnits(vtrac)
);

export const saveVisit = (data) => (
    !process.env.REACT_APP_MOCK ? api.post(apiRoutes.POST_VISIT, data) : () => require('./mock').saveVisit(data)
);

export const updateVisit = (data, vtrac) => (
    !process.env.REACT_APP_MOCK ? api.put(apiRoutes.PUT_VISIT({vtrac}), data) : () => require('./mock').saveVisit(data, vtrac)
);

export const removeVisit = (vtrac) => (
    api.del(apiRoutes.DELETE_VISIT({vtrac}))
);

export const submitVisit = (vtrac) => (
    api.put(apiRoutes.SUBMIT_VISIT({vtrac}))
);

export const saveUnit = (data, vtrac) => (
    api.post(apiRoutes.POST_UNIT({vtrac}), data)
);

export const updateUnit = (data, vtrac, utrac) => (
    api.put(apiRoutes.PUT_UNIT({vtrac, utrac}), data)
);

export const removeUnit = (vtrac, utrac) => (
    !process.env.REACT_APP_MOCK ? api.del(apiRoutes.DELETE_UNIT({vtrac, utrac})) : () => require('./mock').removeUnit(utrac)
);

export const getTimeSlots = (slotEta, dom, days) => (
    api.get(apiRoutes.GET_TIME_SLOTS({slotEta, dom, days}))
);

export const verifyUnit = (payload) => (
    api.post(apiRoutes.VERIFY_UNIT, payload)
);

export const getGoods = (utrac) => (
    api.get(apiRoutes.GET_GOODS({utrac}))
);

export const updateGood = (utrac, data) => (
    api.put(apiRoutes.PUT_GOOD({utrac, trac: data.id}), data)
);

export const saveGood = (utrac, data) => (
    api.post(apiRoutes.POST_GOOD({utrac}), data)
);

export const removeGood = (utrac, id) => (
    api.del(apiRoutes.DELETE_GOOD({utrac, id}))
);

export const getDocs = (utrac) => (
    api.get(apiRoutes.GET_DOCS({utrac}))
);

export const updateDoc = (utrac, data) => (
    api.put(apiRoutes.PUT_DOC({utrac, trac: data.id}), data)
);

export const saveDoc = (utrac, data) => (
    api.post(apiRoutes.POST_DOC({utrac}), data)
);

export const removeDoc = (utrac, id) => (
    api.del(apiRoutes.DELETE_DOC({utrac, id}))
);
